import React, { Component, Fragment } from 'react'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import Undo from 'material-ui/svg-icons/content/undo'
import CircularProgress from '@material-ui/core/CircularProgress'
import ActionDelete from 'material-ui/svg-icons/action/delete'
import IconButton from '@material-ui/core/IconButton'
import ImageEdit from 'material-ui/svg-icons/image/edit'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import { connect } from 'react-redux'
import { readingTimeActions, confirmActions, messageActions } from '../../actions'
import TablePagination from '@material-ui/core/TablePagination'
import Typography from '@material-ui/core/Typography'
import { listTableStyle } from '../../styles'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import { reloadTable } from '../../utils/reloadTable'
import { findPermission, readOnly } from '../../utils/permissions'
import Visibility from '@material-ui/icons/Visibility'

class ListTable extends Component {
  state = {
    debounce: undefined
  }

  componentWillUpdate(newProps) {
    const { pagination, order, fetchReadingTimes, term } = newProps
    const { page, rowsPerPage: perPage } = pagination

    if (reloadTable(newProps, this.props)) {
      const debounce = setTimeout(() => {
        fetchReadingTimes({ page, perPage, order, term })
      }, 700)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }

    return true
  }

  componentDidMount() {
    const { fetchReadingTimes } = this.props
    fetchReadingTimes()
  }

  handleChangePage = (event, page) => {
    const { pagination, handleChangePage, fetchReadingTimes, term } = this.props
    handleChangePage(page)
  }

  handleChangeRowsPerPage = event => {
    const perPage = event.target.value
    const { pagination, fetchReadingTimes, handleChangePerPage, term } = this.props
    handleChangePerPage(perPage)
  }

  handleSortTable = column => {
    const { order, changeOrderColumn, changeOrderDirection } = this.props
    if (column === ((order || {}).column || '')) {
      const direction = ((order || {}).direction || 1) === -1 ? 1 : -1
      changeOrderDirection(direction)
    } else {
      changeOrderColumn(column)
    }
  }

  renderActions = readingTime => {
    const {
      fetchReadingTime,
      removeReadingTime,
      addConfirm,
      token,
      restoreReadingTime
    } = this.props

    return (
      <Fragment>
        {readOnly('tempos_leitura', token) &&
          !readingTime.deletedAt && (
            <IconButton
              onClick={() => {
                fetchReadingTime(readingTime._id)
              }}
            >
              <Visibility nativeColor={'rgba(0, 0, 0, 0.87)'} />
            </IconButton>
          )}

        {!!readingTime.deletedAt && findPermission('tempos_leitura', token).remover ? (
          <IconButton
            onClick={() => {
              const { changeMessage } = this.props

              addConfirm({
                confirmMessage: 'Confirma a restauração deste tempo de leitura?',
                confirmFunction: () => {
                  restoreReadingTime(readingTime._id)
                  changeMessage({ message: 'Restauração realizada com sucesso.' })
                }
              })
            }}
          >
            <Undo />
          </IconButton>
        ) : (
          <Fragment>
            {findPermission('tempos_leitura', token).editar && (
              <IconButton
                onClick={() => {
                  fetchReadingTime(readingTime._id)
                }}
              >
                <ImageEdit />
              </IconButton>
            )}

            {findPermission('tempos_leitura', token).remover && (
              <IconButton
                onClick={() => {
                  const { changeMessage } = this.props

                  addConfirm({
                    confirmMessage: 'Confirma a exclusão deste tempo de leitura?',
                    confirmFunction: () => {
                      removeReadingTime(readingTime._id)
                      changeMessage({ message: 'Exclusão realizada com sucesso.' })
                    }
                  })
                }}
              >
                <ActionDelete />
              </IconButton>
            )}
          </Fragment>
        )}
      </Fragment>
    )
  }

  render() {
    const { classes, readingTimes = [], loadingReadingTimes, pagination, order = {} } = this.props
    return (
      <Paper className={classes.wrapperTable} elevation={4}>
        {!!loadingReadingTimes && (
          <div className={classes.wrapperLoader}>
            <CircularProgress />
          </div>
        )}
        <Table
          fixedHeader={true}
          wrapperStyle={{
            display: 'flex',
            flexDirection: 'column',
            maxHeight: 'var(--crud-table-height)'
          }}
          width={'990px'}
        >
          <TableHeader
            displaySelectAll={false}
            className={classes.tableHeader}
            adjustForCheckbox={false}
          >
            <TableRow>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'nome'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('nome')
                  }}
                >
                  Nome
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'tempo'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('tempo')
                  }}
                >
                  Tempo
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: '100px' }}>Ações</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {(readingTimes || []).length ? (
              (readingTimes || []).map(readingTime => {
                return (
                  <TableRow key={readingTime._id}>
                    <TableRowColumn>{readingTime.nome}</TableRowColumn>
                    <TableRowColumn>
                      {readingTime.tempo[0]} a {readingTime.tempo[1]} min
                    </TableRowColumn>
                    <TableRowColumn style={{ width: '100px' }}>
                      {this.renderActions(readingTime)}
                    </TableRowColumn>
                  </TableRow>
                )
              })
            ) : (
              <TableRow>
                <TableRowColumn>
                  <Typography noWrap style={{ textAlign: 'center', padding: '16px' }}>
                    {!!loadingReadingTimes ? 'Carregando...' : 'Não há registros.'}
                  </Typography>
                </TableRowColumn>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <div className={classes.paginationWrapper}>
          <div className={classes.page}>Página: {pagination.page + 1}</div>
          <TablePagination
            component="div"
            className={classes.pagination}
            labelRowsPerPage="Itens por página"
            labelDisplayedRows={({ from, to, count, page }) => {
              return `Exibindo de ${from} a ${to} de ${count}`
            }}
            rowsPerPageOptions={[25, 50, 100]}
            count={pagination.length}
            rowsPerPage={pagination.rowsPerPage}
            page={pagination.page}
            backIconButtonProps={{
              'aria-label': 'Página anterior'
            }}
            nextIconButtonProps={{
              'aria-label': 'Próxima página'
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </div>
      </Paper>
    )
  }
}

const mapStateToProps = state => {
  return {
    readingTime: state.readingTimes.selected,
    readingTimes: state.readingTimes.list,
    loadingReadingTimes: state.readingTimes.loadingList,
    token: state.auth.token,
    pagination: state.readingTimes.pagination,
    order: state.readingTimes.order,
    term: state.searchTable.term
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(readingTimeActions.openModal())
    },
    closeModal: () => {
      dispatch(readingTimeActions.closeModal())
    },
    fetchReadingTime: id => {
      dispatch(readingTimeActions.fetch(id))
    },
    fetchReadingTimes: options => {
      dispatch(readingTimeActions.index(options))
    },
    removeReadingTime: id => {
      dispatch(readingTimeActions.remove(id))
    },
    addConfirm: ({ confirmMessage, confirmFunction }) => {
      dispatch(confirmActions.addFunction({ confirmMessage, confirmFunction }))
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    },
    handleChangePage: page => {
      dispatch(readingTimeActions.handleChangePage(page))
    },
    handleChangePerPage: perPage => {
      dispatch(readingTimeActions.handleChangePerPage(perPage))
    },
    restoreReadingTime: id => {
      dispatch(readingTimeActions.restore(id))
    },
    changeOrderColumn: column => {
      dispatch(readingTimeActions.changeOrderColumn(column))
    },
    changeOrderDirection: direction => {
      dispatch(readingTimeActions.changeOrderDirection(direction))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(listTableStyle)(ListTable))



// WEBPACK FOOTER //
// ./src/containers/ReadingTime/ListTable.js